module.exports = __webpack_public_path__ + "media/images/icons/soundcloud-4c07e3cc4644a81f46edad78bd3cc704.svg";